module.exports = __webpack_public_path__ + "img/快速开始.aed6b4d1.svg";